
import axios from "axios"

export function getOrderReceiverDropdown (params) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/order/get-receiver-dropdown`, {params})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};